import type { RouterConfig } from '@nuxt/schema'

export default <RouterConfig>{
  scrollBehavior (to, from, savedPosition) {
    if (to.query.apply === '1') {
      return { top: 0, behavior: 'instant' }
    }

    if (savedPosition) {
      return savedPosition
    }

    if (to.hash) {
      return { el: to.hash, top: 0 }
    }

    return { top: 0 }
  },
}
